import React from 'react';
import { Avatar, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import Card from '../card/Card';

const { Text } = Typography;

const ProjectParameters = ({ onParametersClick }) => {
  return (
    <Card>
      <Text style={{ 
        fontSize: 14,
        fontWeight: 600,
        color: '#000',
        display: 'block',
        marginBottom: 16
      }}>
        Configuração de Parâmetros da Empresa
      </Text>
      <div 
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: 16,
          backgroundColor: '#fafafa',
          borderRadius: 8,
          cursor: 'pointer',
          border: '1px solid #f0f0f0',
          transition: 'all 0.2s ease'
        }}
        onClick={onParametersClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f0f0f0';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#fafafa';
        }}
      >
        <Avatar 
          size={48} 
          style={{ 
            backgroundColor: '#722ed1',
            marginRight: 16
          }}
        >
          PE
        </Avatar>
        <div style={{ flex: 1 }}>
          <Text style={{ 
            fontSize: 14, 
            fontWeight: 600,
            display: 'block',
            color: '#000'
          }}>
            Parâmetros da Empresa
          </Text>
          <Text style={{ 
            fontSize: 12, 
            color: '#8c8c8c',
            display: 'block',
            marginTop: 2
          }}>
            Configure módulos e indicadores personalizados
          </Text>
        </div>
        <ArrowRightOutlined style={{ color: '#8c8c8c' }} />
      </div>
    </Card>
  );
};

export default ProjectParameters; 